import { Injectable, signal } from '@angular/core';
import { AgendaSession } from '@base/models/responses/agenda-session.res';

@Injectable({
  providedIn: 'root',
})
export class MediaStateService {
  isPipMode = signal(false);

  detail: AgendaSession | null = null;
  isExternal = false;
}
